var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.launches.length)?_c('div',{staticClass:"launches"},_vm._l((_vm.$store.getters.launches),function(launch,index){return _c('LaunchCard',{key:index,attrs:{"launch":launch}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }